<template>
  <el-row :gutter="20" class="myList">
    <el-col :span="8" v-for="(item, index) in list" :key="index">
      <div class="list-item">
        <router-link :to="{ path: '/goods/details', query: {offerSn:item.offerSn} }">
          <el-image class="item-img"
                    style="width: 100%; height: 100%"
                    :src="$target +item.image"
                    :fit="contain"></el-image>
          <div class="feature-product-name">{{ item.offerName }}</div>
          <div class="feature-product-info">{{ item.offerInfo }}</div>
          <el-button type="primary" plain class="pay-btn">立即购买</el-button>
        </router-link>
      </div>
    </el-col>
    <div style="float: right;display: flex;align-items:center;font-size: 14px ">
      <span style="color: red;font-weight: bold;font-size: 40px;margin-top: 15px">*</span>
      <span>以上商品均可提供发票</span>
    </div>
  </el-row>
</template>
<script>
export default {
  name: "MyList",
  // list为父组件传过来的商品列表
  // isMore为是否显示“浏览更多”
  props: ["list", "isMore", "isDelete"],
  data() {
    return {
      contain:'contain'
    };
  },
  computed: {
    // 通过list获取当前显示的商品的分类ID，用于“浏览更多”链接的参数
    categoryID: function () {
      let categoryID = [];
      if (this.list != "") {
        for (let i = 0; i < this.list.length; i++) {
          const id = this.list[i].category_id;
          if (!categoryID.includes(id)) {
            categoryID.push(id);
          }
        }
      }
      return categoryID;
    }
  },
  methods: {
    deleteCollect(product_id) {
      this.$axios
          .post("/api/user/collect/deleteCollect", {
            user_id: this.$store.getters.getUser.user_id,
            product_id: product_id
          })
          .then(res => {
            switch (res.data.code) {
              case "001":
                // 删除成功
                // 删除删除列表中的该商品信息
                for (let i = 0; i < this.list.length; i++) {
                  const temp = this.list[i];
                  if (temp.product_id == product_id) {
                    this.list.splice(i, 1);
                  }
                }
                // 提示删除成功信息
                this.notifySucceed(res.data.msg);
                break;
              default:
                // 提示删除失败信息
                this.notifyError(res.data.msg);
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
    }
  }
};
</script>
<style scoped>
.myList {
//width: 100%; background-color: #FFFFFF;
  padding: 1.25rem 6.875rem;
  transition: all 0.2s linear;
}

.myList .list-item {
  width: 100%;
}

.myList .list-item .feature-product-name {
  margin-top: 12px;
  font-weight: 400;
  font-size: 22px;
  color: #000000;
}

.myList .list-item .feature-product-info {
  color: #000000;
  margin: 1rem 0;
}

.item-img {
  background-color: #ffffff;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-size: cover;
}

.pay-btn {
  color: #000000;
  background-color: #FFFFFF;
}

</style>